import { defineMessages } from "react-intl"

export const messages = defineMessages({
    pageHeader: {
        id: "merchant_onboarding_page.header",
        defaultMessage: "Activate QuoteMachine Payment within a few minutes."
    },
    activateSectionHeader: {
        id: "merchant_onboarding_page.activate_section.header",
        defaultMessage: "Accept payments in various forms; online, in-person, ACH, and more!"
    },
    activateSectionListItem1: {
        id: "merchant_onboarding_page.activate_section.list_item_1",
        defaultMessage: "Never miss a sale again with the QuoteMachine payments options fully integrated."
    },
    activateSectionListItem2: {
        id: "merchant_onboarding_page.activate_section.list_item_2",
        defaultMessage: "Keep and eye on your cash flow with real-time updates about your sales and inventory."
    },
    activateSectionCheckboxLabel: {
        id: "merchant_onboarding_page.activate_section.checkbox_label",
        defaultMessage: "I've read and I agree to "
    },
    activateSectionAgreement: {
        id: "merchant_onboarding_page.activate_section.agreement",
        defaultMessage: "QuoteMachine Payment Processing Agreement"
    },
    activateSectionButton: {
        id: "merchant_onboarding_page.activate_section.button",
        defaultMessage: "Activate payments"
    },
    feesSectionHeader: {
        id: "merchant_onboarding_page.fees_section.header",
        defaultMessage: "Exclusive Rates"
    },
    feesSectionCreditCardPresent: {
        id: "merchant_onboarding_page.fees_section.credit_card_present",
        defaultMessage: "Credit Card-present"
    },
    feesSectionCreditCardNotPresent: {
        id: "merchant_onboarding_page.fees_section.credit_card_not_present",
        defaultMessage: "Credit Card-not-present"
    },
    feesSectionAmex: {
        id: "merchant_onboarding_page.fees_section.amex",
        defaultMessage: "Amex Surcharge"
    },
    feesSectionAch: {
        id: "merchant_onboarding_page.fees_section.ach",
        defaultMessage: "ACH"
    },
    faqHeader: {
        id: "merchant_onboarding_page.faq.header",
        defaultMessage: "Frequently Asked Questions"
    },
    faqQuestion1: {
        id: "merchant_onboarding_page.faq.question_1",
        defaultMessage: "Do I need to pay more to activate QuoteMachine Payments?"
    },
    faqAnswer1: {
        id: "merchant_onboarding_page.faq.answer_1",
        defaultMessage: "No, QuoteMachine Payments is included in your QuoteMachine subscription."
    },
    faqQuestion2: {
        id: "merchant_onboarding_page.faq.question_2",
        defaultMessage: "Do you offer in-person payment acceptance?"
    },
    faqAnswer2: {
        id: "merchant_onboarding_page.faq.answer_2",
        defaultMessage: "Yes, with QuoteMachine Payments you can accept payments online and in-person."
    },
    faqQuestion3: {
        id: "merchant_onboarding_page.faq.question_3",
        defaultMessage: "Are there hidden fees?"
    },
    faqAnswer3: {
        id: "merchant_onboarding_page.faq.answer_3",
        defaultMessage: "We offer simple pricing with no-hidden fees."
    },
    faqQuestion4: {
        id: "merchant_onboarding_page.faq.question_4",
        defaultMessage: "Does QuoteMachine support accepting credit card payments?"
    },
    faqAnswer4: {
        id: "merchant_onboarding_page.faq.answer_4",
        defaultMessage: "Yes, we accept all major credit cards."
    },
    faqQuestion5: {
        id: "merchant_onboarding_page.faq.question_5",
        defaultMessage: "Can buyers save cards on file?"
    },
    faqAnswer5: {
        id: "merchant_onboarding_page.faq.answer_5",
        defaultMessage: "Yes, we support cards on file online and on the terminal."
    },
    faqQuestion6: {
        id: "merchant_onboarding_page.faq.question_6",
        defaultMessage: "Does QuoteMachine offer ACH payment capabilities?"
    },
    faqAnswer6: {
        id: "merchant_onboarding_page.faq.answer_6",
        defaultMessage: `QuoteMachine offers an easy electronic payment offering for accepting bank payments.\n
            Our newly updated ACH integration speeds up verification of accounts so that new ACH customers can pay in real time, once verified.`
    },
    accountNameLabel: {
        id: "merchant_onboarding_page.activate_section.account_name_label",
        defaultMessage: "Account Name"
    },
    accountNamePlaceholder: {
        id: "merchant_onboarding_page.activate_section.account_name_placeholder",
        defaultMessage: "Name your QM payment account..."
    },
    mccLabel: {
        id: "merchant_onboarding_page.activate_section.mcc_label",
        defaultMessage: "Select your MCC"
    },
    assignLocations: {
        id: "merchant_onboarding_page.activate_section.assign_locations_label",
        defaultMessage: "Assign locations"
    },
    testMode: {
        id: "merchant_onboarding_page.activate_section.test_mode",
        defaultMessage: "Test Mode"
    },
    testModeInfo: {
        id: "merchant_onboarding_page.activate_section.test_mode_info",
        defaultMessage: "Your QuoteMachine account is currently using the Test Mode for payments."
    },
    trialTestModeInfo: {
        id: "merchant_onboarding_page.activate_section.trial_info",
        defaultMessage: "Get the most out of QuoteMachine ! To access QuoteMachine Payments, please {upgrade_link}."
    },
    trialTestModeActivateInfo1: {
        id: "merchant_onboarding_page.activate_section.test_mode_trial_info1",
        defaultMessage: "Explore the possibilities in Test Mode! Use {link} to discover the benefits of QuoteMachine Payments."
    },
    trialTestModeActivateInfo2: {
        id: "merchant_onboarding_page.activate_section.test_mode_trial_info2",
        defaultMessage: "To fully integrate these features into your workflow, {upgrade_link} and enjoy uninterrupted access."
    },
    trialUpgradeSubscription: {
        id: "merchant_onboarding_page.activate_section.trial_upgrade_subscription",
        defaultMessage: "upgrade your subscription"
    },
})


// WEBPACK FOOTER //
// ./src/payment-processing/merchant-onboarding/messages.ts